import GenerateDescriptionComponent from 'components/Login/CreateProfile/GenerateDescriptionComponent';

const ClientSignUpElements = (props) => {
  const {
    clientContainer,
    clientProperties,
    disabledClientName,
    error,
    setError,
    setActiveItem,
    clientRef,
    clientWebsiteRef,
    isLoadingGenerationState,
  } = props;
  const { clientName, setClientName, agencyStep, clientWebsite, setClientWebsite } = clientProperties ?? {};

  return (
    <>
      {agencyStep === 'createTopic' ? (
        <>
          <div className='form-group my-4'>
            <label className='title-h5-m-bold mb-3'>Client name</label>
            <div ref={clientContainer}>
              <input
                data-hj-allow
                value={clientName}
                type='text'
                disabled={disabledClientName}
                className='form-control create-name-topic-input bg-white main-input signup-topic-input'
                onChange={(e) => {
                  setClientName(e.target.value);
                  setError({ type: '', message: '' });
                }}
                onFocus={() => {
                  setActiveItem('clientName');
                }}
                ref={clientRef}
                placeholder={'Start typing...'}
              />
              {error.type === 'clientName' && (
                <p className='mb-0 profile-error-message py-2 px-3 mt-2'>{error.message}</p>
              )}
            </div>
          </div>
          <div className='form-group my-4'>
            <label className='title-h5-m-bold mb-3'>Client website</label>
            <input
              data-hj-allow
              value={clientWebsite}
              type='text'
              className='form-control create-name-topic-input bg-white main-input signup-topic-input'
              onChange={(e) => {
                setClientWebsite(e.target.value);
                setError({ type: '', message: '' });
              }}
              onFocus={() => {
                setActiveItem('clientWebsite');
              }}
              ref={clientWebsiteRef}
              placeholder={'Start typing...'}
            />
            {error.type === 'clientWebsite' && (
              <p className='mb-0 profile-error-message py-2 px-3 mt-2'>{error.message}</p>
            )}
          </div>
        </>
      ) : (
        <ClientSignupDescription
          clientProperties={clientProperties}
          setError={setError}
          error={error}
          isLoadingGenerationState={isLoadingGenerationState}
          clientWebsite={clientWebsite}
        />
      )}
    </>
  );
};

const ClientSignupDescription = (props) => {
  const { clientProperties, setError, error, isLoadingGenerationState, clientWebsite } = props ?? {};
  const { clientDescription, setClientDescription, clientName } = clientProperties ?? {};

  const { isLoadingGeneration, setIsLoadingGeneration } = isLoadingGenerationState ?? {};

  return (
    <>
      <GenerateDescriptionComponent
        teamName={clientName}
        clientDescriptionState={{ clientDescription, setClientDescription }}
        loadingState={{ isLoading: isLoadingGeneration, setIsLoading: setIsLoadingGeneration }}
        errorElement={() => {
          <>
            {error.type === 'clientDescription' && (
              <p className='mb-0 profile-error-message py-2 px-3 mt-2'>{error.message}</p>
            )}
          </>;
        }}
        errorFunction={() => {
          setError({
            type: 'clientDescription',
            message: 'Please enter a description that is at least 100 characters',
          });
        }}
        boxClass={'bg-main-white text-main-blue'}
        notAutoGenerate={clientDescription?.trim() !== ''}
        clientWebsite={clientWebsite}
      />
    </>
  );
};

export default ClientSignUpElements;
